export default "__VITE_ASSET__CgZcmpmy__"